<template>
  <div>
    <VueSelect
      :value="value"
      :input-id="inputId"
      :options="empresas"
      :get-option-label="nomeEmpresa"
      :filterable="false"
      :loading="carregando"
      :disabled="disabled"
      placeholder="Busque pelo nome ou CNPJ/CPF"
      @input="$emit('input', $event)"
      @search="buscar"
    >
      <template #no-options>
        {{
          carregando ? "Carregando empresas..." : "Nenhuma empresa encontrada."
        }}
      </template>
      <template #list-footer>
        <li
          v-if="pagina < ultimaPagina"
          class="text-center p-2"
          role="presentation"
        >
          <button
            type="button"
            class="btn btn-sm btn-light-primary"
            :disabled="carregando"
            @click="carregarMais"
          >
            Carregar mais empresas
          </button>
        </li>
      </template>
    </VueSelect>
    <small v-if="erro" class="text-danger" role="alert">{{ erro }}</small>
  </div>
</template>

<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "EmpresaParceiroSelect",
  components: { VueSelect },
  props: {
    value: { type: Object, default: null },
    inputId: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      empresas: [],
      busca: "",
      pagina: 0,
      ultimaPagina: 1,
      carregando: false,
      erro: "",
      sequencia: 0,
      timer: null,
    };
  },
  mounted() {
    this.carregar();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    this.sequencia++;
  },
  methods: {
    nomeEmpresa(empresa) {
      return `${empresa.nome || empresa.nome_fantasia || "Empresa"} (${
        empresa.cnpj_cpf || "sem documento"
      }) · #${empresa.id_empresa}`;
    },
    buscar(busca) {
      clearTimeout(this.timer);
      this.sequencia++;
      this.busca = busca;
      this.empresas = [];
      this.pagina = 0;
      this.ultimaPagina = 1;
      this.carregando = true;
      this.timer = setTimeout(() => this.carregar(), 300);
    },
    carregarMais() {
      if (!this.carregando && this.pagina < this.ultimaPagina) {
        return this.carregar(this.pagina + 1);
      }
    },
    async carregar(pagina = 1) {
      const sequencia = ++this.sequencia;
      this.carregando = true;
      this.erro = "";
      try {
        const { data } = await this.$http.get(
          "/revenda/cadastros-fiscais/empresas",
          {
            params: { busca: this.busca, page: pagina, per_page: 20 },
          }
        );
        if (sequencia !== this.sequencia) return;
        const anteriores = pagina === 1 ? [] : this.empresas;
        const empresas = new Map(
          anteriores.map((empresa) => [Number(empresa.id_empresa), empresa])
        );
        data.data.forEach((empresa) =>
          empresas.set(Number(empresa.id_empresa), empresa)
        );
        this.empresas = Array.from(empresas.values());
        this.pagina = data.current_page;
        this.ultimaPagina = data.last_page;
      } catch (error) {
        if (sequencia === this.sequencia) {
          this.erro =
            "Não foi possível carregar as empresas. Faça uma nova busca para tentar novamente.";
        }
      } finally {
        if (sequencia === this.sequencia) this.carregando = false;
      }
    },
  },
};
</script>
